// @flow

export { default } from './Link';
